/**
 * The one link that starts a manual ingestion.
 *
 * Kept in its own module so a screen can send someone into the upload flow
 * without importing the Documents explorer (and its charts, table and CSS) just
 * to name a route — and so the `upload` query flag is spelled in exactly one
 * place. {@link module:screens/documents/DocumentsScreen} is what reads it.
 */
export const UPLOAD_PATH = '/documents?upload=1';
